import React from 'react';

export const BoxImg = () => (
  <svg
    width="100%"
    height={181}
    viewBox="0 0 296 181"
    xmlns="http://www.w3.org/2000/svg"
    fillRule="evenodd"
    clipRule="evenodd"
    strokeLinejoin="round"
    strokeMiterlimit="2"
  >
    <path
      d="M222.706 105.111c-6.762-5.926-2.818-11.028 0-12.839-57.756-2.469-170.837-5.926-161.117 0 9.719 5.926 4.049 12.345 0 14.814 56.523 1.811 167.878 3.951 161.117-1.975zM238.5 73.313c-6.4-6-2.667-11.167 0-13-54.667-2.5-161.7-6-152.5 0 9.2 6 3.833 12.5 0 15 53.5 1.833 158.9 4 152.5-2z"
      fill="#f4f5f7"
      fillRule="nonzero"
    />
    <path
      d="M260 51c0-6.623-5.377-12-12-12H12C5.377 39 0 44.377 0 51s5.377 12 12 12h236c6.623 0 12-5.377 12-12zM296 83c0-6.623-5.377-12-12-12H48c-6.623 0-12 5.377-12 12s5.377 12 12 12h236c6.623 0 12-5.377 12-12zM245 113c0-5.519-4.481-10-10-10H27c-5.519 0-10 4.481-10 10s4.481 10 10 10h208c5.519 0 10-4.481 10-10z"
      fill="#f4f5f7"
    />
    <path
      d="M218 146.228L148.5 181 79 146.228 148.5 112l69.5 34.228z"
      fill="#f4f5f7"
      fillRule="nonzero"
    />
    <path
      d="M168.185 6l63.584 31.477-20.185 19.292-62.738-31.73L168.185 6zM128.661 6L65.077 37.477l20.185 19.292 63.584-31.73L128.661 6z"
      fill="#e5e7eb"
      fillRule="nonzero"
    />
    <path
      d="M148.846 25.039l63.462 31.914v58.201L148.846 91.71V25.039z"
      fill="#d1d4dc"
      fillRule="nonzero"
    />
    <path
      d="M148.846 25.039L84.538 56.953v58.201l64.308-23.444V25.039z"
      fill="#9fa5b2"
      fillRule="nonzero"
    />
    <path
      d="M84.539 55.923l64.307 31.786L148.5 147l-63.961-31.478V55.923z"
      fill="#dcdee4"
      fillRule="nonzero"
    />
    <path d="M211 56.5L148.5 87v60l63.808-31.478L211 56.5z" fill="#9fa5b2" fillRule="nonzero" />
    <path
      d="M85.509 56l64.337 31.574L125.337 111 61 79.426 85.509 56z"
      fill="#e5e7eb"
      fillRule="nonzero"
    />
    <path
      d="M211.491 55.923l-64.337 31.574 24.509 23.426L236 79.349l-24.509-23.426z"
      fill="#e5e7eb"
      fillRule="nonzero"
    />
  </svg>
);
